'use client';
import { useRichTreeViewApiRef } from './useRichTreeViewApiRef';

/**
 * Hook that instantiates a [[TreeViewApiRef]].
 * @deprecated Use `useRichTreeViewApiRef()`, `useRichTreeViewProApiRef()` or `useSimpleTreeViewApiRef()` instead.
 */
export const useTreeViewApiRef = useRichTreeViewApiRef;
